export type ScheduleView = "week" | "twoWeeks" | "month";

export function isScheduleDate(dateKey: string): boolean {
  if (typeof dateKey !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) return false;
  const date = new Date(`${dateKey}T12:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === dateKey;
}

export function addScheduleDays(dateKey: string, count: number): string {
  const date = new Date(`${dateKey}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + count);
  return date.toISOString().slice(0, 10);
}

export function schedulePeriod(anchor: string, view: ScheduleView): { start: string; end: string; days: string[] } {
  const date = new Date(`${anchor}T12:00:00Z`);
  const start = view === "month" ? `${anchor.slice(0, 7)}-01`
    : addScheduleDays(anchor, -((date.getUTCDay() + 6) % 7));
  const count = view === "month" ? new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0, 12)).getUTCDate()
    : view === "twoWeeks" ? 14 : 7;
  const days = Array.from({ length: count }, (_, index) => addScheduleDays(start, index));
  return { start, end: addScheduleDays(start, count - 1), days };
}

export function moveSchedulePeriod(anchor: string, view: ScheduleView, direction: -1 | 1): string {
  if (view !== "month") return addScheduleDays(anchor, direction * (view === "week" ? 7 : 14));
  const date = new Date(`${anchor.slice(0, 7)}-01T12:00:00Z`);
  date.setUTCMonth(date.getUTCMonth() + direction);
  return date.toISOString().slice(0, 10);
}

/** Nominal local-clock duration. Equal times are invalid, rather than an assumed 24h shift. */
export function nominalShiftMinutes(start: string, end: string): number | null {
  const clock = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  if (!clock.test(start) || !clock.test(end) || start === end) return null;
  const minutes = (value: string) => Number(value.slice(0, 2)) * 60 + Number(value.slice(3));
  return (minutes(end) - minutes(start) + 1440) % 1440;
}
